import { BemMethod, createBem } from '@om-fe/utils';

export const breadcrumbsBem: BemMethod = createBem('Breadcrumbs');

export const SCROLL_INTO_VIEW_OPTIONS: ScrollIntoViewOptions = { behavior: 'smooth', block: 'center', inline: 'end' };

